export default "__VITE_ASSET__56304eda__"